var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportContactsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26.11 25.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4,.cls-5{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{stroke:#c0d0d7;stroke-miterlimit:10;stroke-width:2.5px;}.cls-4,.cls-5{stroke-linecap:round;}.cls-5{stroke:#334662;stroke-linejoin:round;stroke-width:2px;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:#334662;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 26.11,
    height: 25.99
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 26.11,
    height: 25.99
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.58,11.84h0a1,1,0,0,0-.06,1.41L13,21.32l7.5-8.06a1,1,0,0,0-.05-1.41,1,1,0,0,0-.68-.27,1,1,0,0,0-.73.31h0l-6,6.49L7,11.9a1,1,0,0,0-.73-.32,1,1,0,0,0-.68.26"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.67,19.54v3a2,2,0,0,1-2,2H3.37a2,2,0,0,1-2-2v-3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 13.02,
    y1: 1.37,
    x2: 13.02,
    y2: 19.15
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0.26,
    y: 6.58,
    width: 25.53,
    height: 19.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportContactsIcon);
export default __webpack_public_path__ + "static/media/import-contacts-icon.32e34cc154d21548915e68da22834b09.svg";
export { ForwardRef as ReactComponent };